import React from 'react';
import { ChevronLeft } from '@olxbr/ds-icons';
import { ChevronRight } from '@olxbr/ds-icons';
import { VisuallyHidden } from '../../../VisuallyHidden';
import { useScrollVisibility } from './useScrollVisibility';
import * as Styles from './styles';
/**
 * Componente Tabs do Design System OLX.
 * A estrutura de Tabs possui componentes auxiliares necessários: Tab e TabPanel
 */
export const Tablist = _ref => {
  let {
    children,
    selectedTabId,
    onSelectTab
  } = _ref;
  const tabButtons = React.Children.toArray(children);
  const {
    isScrollLeftButtonVisible,
    isScrollRightButtonVisible,
    handleShiftButtonClick,
    tabsContentRef
  } = useScrollVisibility({
    tabButtons,
    selectedTabId,
    onSelectTab
  });
  return React.createElement(Styles.TabList, null, React.createElement(Styles.TabListButton, {
    className: "".concat(!isScrollLeftButtonVisible ? 'hidden' : '', " left"),
    onClick: () => handleShiftButtonClick('left'),
    "data-ds-component": "DS-Tabs-Button",
    "data-testid": "ds-tabs-scroll-left"
  }, React.createElement(ChevronLeft, null), React.createElement(VisuallyHidden, null, "Scroll para a esquerda")), React.createElement(Styles.TabsContent, {
    ref: tabsContentRef
  }, React.createElement(Styles.TabButonsWrapper, null, children)), React.createElement(Styles.TabListButton, {
    className: "".concat(!isScrollRightButtonVisible ? 'hidden' : '', " right"),
    onClick: () => handleShiftButtonClick('right'),
    "data-ds-component": "DS-Tabs-Button",
    "data-testid": "ds-tabs-scroll-right"
  }, React.createElement(ChevronRight, null), React.createElement(VisuallyHidden, null, "Scroll para a direita")));
};
Tablist.displayName = 'Tablist';